import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"volume-down"} maskId="square-filled-radius-0-stroke-1-IconVolumeDown"><path d="M13 2.88428V21.1157L5.86611 17H1V6.99998H5.86611L13 2.88428Z" fill="currentColor"/><path d="M23 11.5H15V12.5H23V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVolumeDown;
